export default class formConfig {
  // 流程设定表
  static configList() {
    return [
      {
        title: "流程设定信息",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "流程名称：",
            type: "input",
            value: "processName",
            placeholder: "请输入",
            maxlength: 100,
            rule: {
              required: true,
              message: "请填写流程名称",
              trigger: "blur"
            }
          },
          {
            label: "流程编号：",
            type: "input",
            value: "processCode",
            placeholder: "请输入",
            maxlength: 36,
            disabled: true,
          },
        ]
      },
      {
        title: "流程设定",
        name: "2",
        icon: "",
        tipsList: [
          { text: "流程编号请按照下面提示输入：" },
          { text: "1.招标人（T）招标代理（A）投标人（B）" },
          { text: "2.是否项目类（C）：项目类（1）、非项目类（0）" },
          { text: "3.是否目录内（D）：目录内（1）、非目录内（0）" },
          { text: "4.招标组织形式（E）：自行组织（1）、委托招标（2）" },
          { text: "5.招标方式（F）：公开招标（1）、邀请招标（2）" },
          { text: "6.是否联合体招标（G）：联合体（1）、非联合体（0）" },
          { text: "7.资格审查方式（H）：资格预审（1）、资格后审（2）" },
          { text: "8.国产化项目（X）：是（1）" },
          { text: "9.项目登记（Z1），招标代理备案（W1），招标登记（N1）" },
          { text: "例如：招标人-项目类-目录内-自行招标-公开招标-联合体-资格预审" },
          { text: "流程编号：TC1D1E1F1G1H1" },
        ],
        formConfigList: [
          {
            label: "用户类型：",
            value: "userType",
            type: "select",
            clearable: true,
            optionData: [
              { name: "招标人", value: "T" },
              { name: "招标代理", value: "A" },
              { name: "投标人", value: "B" },
            ],
            rule: {
              required: false,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
          {
            label: "是否项目类：",
            value: "constructionNo",
            type: "select",
            clearable: true,
            optionData: [
              { name: "项目类", value: "C1" },
              { name: "非项目类", value: "C0" },
            ],
            rule: {
              required: false,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
          {
            label: "是否目录内：",
            value: "applicationNo",
            type: "select",
            clearable: true,
            optionData: [
              { name: "目录内", value: "D1" },
              { name: "非目录内", value: "D0" },
            ],
            rule: {
              required: false,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
          {
            label: "招标组织形式：",
            value: "tenderMethodNo",
            type: "select",
            clearable: true,
            optionData: [
              { name: "自行组织", value: "E1" },
              { name: "委托招标", value: "E2" },
            ],
            rule: {
              required: false,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
          {
            label: "招标方式：",
            value: "tenderTypeNumNo",
            type: "select",
            clearable: true,
            optionData: [
              { name: "公开招标", value: "F1" },
              { name: "邀请招标", value: "F2" },
            ],
            rule: {
              required: false,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
          {
            label: "是否联合体招标：",
            value: "isUnionTenderNo",
            type: "select",
            clearable: true,
            optionData: [
              { name: "联合体", value: "G1" },
              { name: "非联合体", value: "G0" },
            ],
            rule: {
              required: false,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
          {
            label: "资格审查方式：",
            value: "prequalificationTypeNo",
            type: "select",
            clearable: true,
            optionData: [
              { name: "资格预审", value: "H1" },
              { name: "资格后审", value: "H2" },
            ],
            rule: {
              required: false,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
          {
            label: "是否允许投标单位为联合体：",
            value: "isUnionCorpEnrollNo",
            type: "select",
            clearable: true,
            optionData: [
              { name: "联合体", value: "J1" },
              { name: "非联合体", value: "J0" },
            ],
            rule: {
              required: false,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
          {
            label: "项目编号：",
            value: "constructionIdNo",
            type: "select",
            clearable: true,
            optionData: [
              { name: "项目登记", value: "Z1" },
            ],
            rule: {
              required: false,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
          {
            label: "招标代理备案项目：",
            value: "agencyCorpRecordNo",
            type: "select",
            clearable: true,
            optionData: [
              { name: "招标代理备案", value: "W1" },
            ],
            rule: {
              required: false,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
          {
            label: "国产化项目：",
            value: "oldFlagNo",
            type: "select",
            clearable: true,
            optionData: [
              { name: "是", value: "X1" },
            ],
            rule: {
              required: false,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
        ]
      },
      {
        title: "流程设定详情",
        name: "3",
        icon: "",
        formConfigList: [
          {
            label: "",
            type: "slot",
            slotName: "detailList",
            class: "table formList",
          },
        ]
      },
    ];
  }
}
